import { render, staticRenderFns } from "./AutocompleteItem.vue?vue&type=template&id=d4c04734&"
import script from "./AutocompleteItem.vue?vue&type=script&lang=js&"
export * from "./AutocompleteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports